import styled from "@emotion/styled";

export const IconContainer = styled.div`
  inline-size: 33px;
  block-size: 33px;

  opacity: 0.3;

  a {
    inline-size: inherit;
    block-size: inherit;

    line-height: 0;

    svg {
      inline-size: inherit;
      block-size: inherit;
    }
  }
`;

export const Container = styled.div`
  display: flex;
  ${IconContainer}:not(:last-child) {
    margin-inline-end: 12px;
  }
`;
